// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvatarMakerController from "./avatar_maker_controller"
application.register("avatar-maker", AvatarMakerController)

import BusinessStartController from "./business_start_controller"
application.register("business-start", BusinessStartController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MarketingController from "./marketing_controller"
application.register("marketing", MarketingController)

import PasskeyController from "./passkey_controller"
application.register("passkey", PasskeyController)

import PublicLearnController from "./public_learn_controller"
application.register("public-learn", PublicLearnController)

import SectionNavController from "./section_nav_controller"
application.register("section-nav", SectionNavController)

import ShopWindowController from "./shop_window_controller"
application.register("shop-window", ShopWindowController)

import SignInController from "./sign_in_controller"
application.register("sign-in", SignInController)

import SignOutController from "./sign_out_controller"
application.register("sign-out", SignOutController)

import SiteMenuController from "./site_menu_controller"
application.register("site-menu", SiteMenuController)

import SubmitOnChangeController from "./submit_on_change_controller"
application.register("submit-on-change", SubmitOnChangeController)

import ToastsController from "./toasts_controller"
application.register("toasts", ToastsController)

import ToolHelpController from "./tool_help_controller"
application.register("tool-help", ToolHelpController)

import ToolIntroController from "./tool_intro_controller"
application.register("tool-intro", ToolIntroController)

import ToolsMoreController from "./tools_more_controller"
application.register("tools-more", ToolsMoreController)

import WorkbenchLinkController from "./workbench_link_controller"
application.register("workbench-link", WorkbenchLinkController)

import WorkbenchPinController from "./workbench_pin_controller"
application.register("workbench-pin", WorkbenchPinController)
